import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
    Title,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
ChartJS.register(
    ArcElement,
    Tooltip,
    Legend,
    Title,
    ChartDataLabels
);

const DonutChart = ({ data, title }) => {
    const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '60%', // Imposta quanto grande è il buco (puoi aumentare fino a ~90%)
        plugins: {
            title: {
                display: true,
                text: title,
                font: {
                    size: 24,
                },
                color: '#fff',
            },
            legend: {
                position: 'bottom',
                labels: {
                    color: '#fff',
                    font: {
                        size: 16,
                    },
                },
            },
            datalabels: {
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 16,
                },
                /*formatter: (value, context) => {
                    const data = context.chart.data.datasets[0].data;
                    const total = data.reduce((acc, val) => acc + val, 0);
                    const percentage = ((value / total) * 100).toFixed(1);
                    return `${percentage}%`;
                },*/
            },
        },
    };

    return (
        <div className="graph">
            <Doughnut data={data} options={options} />
        </div>
    );
};

export default DonutChart;
